import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import BankStatementTemplateFields from './BankStatementTemplateFields'

export const BankStatementTemplateEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <BankStatementTemplateFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default BankStatementTemplateEdit
